import { useEffect, useState } from 'react';

import { relativeTime } from '../../i18n/el';

// Το κείμενο ανανεώνεται όσο το στοιχείο είναι στην οθόνη, ώστε το «πριν από ένα
// λεπτό» να μη μένει παγωμένο σε σελίδα που παραμένει ανοιχτή (ΜΛΑ-04).
//
// Ο υπολογισμός και η διατύπωση ζουν στο `i18n/el.js`, μαζί με τα υπόλοιπα
// ελληνικά: εδώ μένει μόνο ο κύκλος ζωής του χρονομετρητή.
const REFRESH_INTERVAL = 60000;

export default function TimeAgo({ date, className = '' }) {
    const [text, setText] = useState(() => relativeTime(date));

    useEffect(() => {
        const next = relativeTime(date);
        setText(next);

        if (!next) {
            // Στον χρήστη δεν εμφανίζεται τίποτα, αλλά μια τιμή που λείπει από το API
            // δεν πρέπει να περνά σιωπηλά κατά την ανάπτυξη.
            if (import.meta.env.DEV) {
                console.warn('TimeAgo: missing or invalid date', date);
            }
            return;
        }

        const timer = setInterval(() => setText(relativeTime(date)), REFRESH_INTERVAL);
        return () => clearInterval(timer);
    }, [date]);

    if (!text) return null;

    // Το `dateTime` πρέπει να είναι μηχανικά αναγνώσιμο, ανεξάρτητα από τη γλώσσα
    // του κειμένου: είναι το μόνο σημείο όπου η ημερομηνία μένει σε ISO.
    //
    // **Το `className` εφαρμόζεται.** Δύο κλήσεις του το έδιναν και το συστατικό το
    // πετούσε: το JSX δέχεται κάθε ιδιότητα χωρίς παράπονο, και μια ιδιότητα που δεν
    // διαβάζεται δεν παράγει ούτε σφάλμα ούτε προειδοποίηση. Η συνέπεια ήταν ότι η
    // ημερομηνία του σχολίου έμενε στο αριστερό άκρο αντί να στοιχίζεται με τη
    // φυσαλίδα, και σε κανονικό μέγεθος αντί για μικρότερο — δηλαδή ακριβώς η
    // μορφοποίηση που ζητούσε ο καλών και που φαινόταν γραμμένη.
    return <time className={className} dateTime={new Date(date).toISOString()}>{text}</time>;
}
